module.exports = __webpack_public_path__ + "img/extra_assign.7dce43b2.svg";